import { APIProvider } from '@vis.gl/react-google-maps';
import type { ReactNode } from 'react';

import { env } from '@/lib/env';

/**
 * Wraps the app's map subtree in the Google Maps JS API loader. The key is optional
 * (env schema) — under VITE_MOCK_API with no key the map renders a grey canvas, which
 * is fine for prototype UX; markers/polygons/draw logic still work against mock data.
 */
export function MapProvider({ children }: { children: ReactNode }) {
  return (
    <APIProvider apiKey={env.VITE_GOOGLE_MAPS_API_KEY ?? ''} libraries={['geometry', 'marker']}>
      {children}
    </APIProvider>
  );
}
